module.exports = __webpack_public_path__ + "static/img/slide_text_1.857fa6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/slide_text_1.png
// module id = 611M
// module chunks = 51